import * as React from 'react'
import { Button } from 'antd'
import { BarcodeModal } from './BarcodeModal'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { IBaseProduct, InvoiceStatus, CreateInvoiceLine } from '@getgreenline/homi-shared'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { observer } from 'mobx-react-lite'

interface Props {
  className?: string
  createInvoice: CreateInvoiceDetail
  setCostPerUnit: (companyId: number, product: IBaseProduct, line: CreateInvoiceLine) => void
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const InvoiceBarcodeScan = inject('currentCompanyStore')(
  observer((props: Props & InjectedProps) => {
    const { className, createInvoice, setCostPerUnit, currentCompanyStore } = props

    const company = currentCompanyStore!.company!
    const [isScanning, setIsScanning] = React.useState(false)

    const submitBarcodeScan = async (product: IBaseProduct, batchNumber?: string) => {
      const invoiceStatus = createInvoice.invoiceDetail && createInvoice.invoiceDetail.status

      // If completed and the product is lot tracked, don't do anything
      if (product.isBatchTracked && invoiceStatus === InvoiceStatus.COMPLETED) {
        return
      }

      // If line already exists, increase quantity. Otherwise, add new line
      let invoiceLine = createInvoice.lines.find((line) => line.productId === product.id)

      if (invoiceLine) {
        invoiceLine.setQuantityReceived((invoiceLine.quantityReceived || 0) + 1)
      } else {
        const createdLine = createInvoice.addProduct(product)
        await setCostPerUnit(company.id, product, createdLine)
        createdLine.setQuantityReceived(1)

        invoiceLine = createdLine
      }

      // Add the lot, if exists
      if (product.isBatchTracked && batchNumber && invoiceLine) {
        invoiceLine.addBatch({ batchNumber, quantity: 1 })
      }
    }

    return (
      <>
        <Button
          icon='barcode'
          loading={isScanning}
          className={className}
          onClick={() => setIsScanning(true)}
        >
          Scan barcode
        </Button>

        {isScanning && (
          <BarcodeModal
            companyId={company.id}
            onClose={() => setIsScanning(false)}
            onScanSuccess={(product, batchNumber) => submitBarcodeScan(product, batchNumber)}
          />
        )}
      </>
    )
  }),
)
